import React, { memo } from 'react';
import { Map, Marker } from 'google-maps-react';
import { mapStyle } from 'utils/maps/mapStyle';

type MapContainerProps = {
    position: { lat: number; lng: number };
    disableDefaultUI?: boolean;
    zoom?: number;
};

const mapStyles: React.CSSProperties = {
    position: 'relative',
    width: '100%',
    height: '100%',
};

export const MapContainer = memo(function MapContainer({
    position: { lat, lng },
    disableDefaultUI,
    zoom,
}: MapContainerProps) {
    const g = typeof window !== 'undefined' ? (window as any).google : undefined;
    if (!g) return null;

    const onMapLoaded = (_mapProps: any, map?: google.maps.Map) => {
        if (!map) return;
        map.setOptions({ styles: mapStyle, disableDefaultUI });
    };

    return (
        <Map
            {...({
                google: g,
                zoom,
                style: mapStyles,
                initialCenter: { lat, lng },
                center: { lat, lng },
                disableDefaultUI,
                onReady: (mp: any, m?: google.maps.Map) => onMapLoaded(mp, m),
            } as any)}
        >
            <Marker title="Position du TOTEM" position={{ lat, lng }} />
        </Map>
    );
});
